import * as yup from 'yup';

export default function nullableStringMax(label, max) {
  return yup.string().max(max).label(label).nullable();
}
